import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "block border-2 border-nucleus-primaryBlue bg-white text-nucleus-text hover:bg-nucleus-primaryMouseOver hover:text-white p-1 text-sm text-center shadow-md rounded-full transition relative"
}
const _hoisted_2 = {
  key: 0,
  class: "absolute w-full h-full top-0 left-0 rounded-full bg-nucleus-primaryBlue text-white flex justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "loader ease-linear rounded-full border-2 border-t-2 border-nucleus-primaryMouseOver h-6 w-6 animate-spin" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.name), 1)
  ]))
}